import React, { FunctionComponent } from 'react';

type Props = {
  year: string;
  month: string;
  day: string;
  yearList: string[];
  monthList: string[];
  dayList: string[];
  onChange: (name: 'year' | 'month' | 'day', value: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  year,
  month,
  day,
  yearList,
  monthList,
  dayList,
  onChange,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">生年月日を選択して保存してください</p>
      <div className="person__show__modal__inner__box__wrapper">
        <div className="person__show__modal__inner__box__date">
          <select
            className="year"
            name="year"
            value={year}
            onChange={(e) => onChange('year', e.target.value)}
          >
            <option value="" disabled hidden>
              西暦
            </option>
            {yearList.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <span>年</span>
        </div>

        <div className="person__show__modal__inner__box__date">
          <select
            className="month"
            name="month"
            value={month}
            onChange={(e) => onChange('month', e.target.value)}
          >
            <option value="" disabled hidden>
              月
            </option>
            {monthList.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
          <span>月</span>
        </div>

        <div className="person__show__modal__inner__box__date">
          <select
            className="month"
            name="day"
            value={day}
            onChange={(e) => onChange('day', e.target.value)}
          >
            <option value="" disabled hidden>
              日
            </option>
            {dayList.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
          <span>日</span>
        </div>
      </div>
    </div>
  );
};
